import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="layout">
      <div className="layout__container">
        <div className="layout__section" style={{ 
          textAlign: 'center', 
          paddingTop: '4rem'
        }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            marginBottom: '1rem', 
            fontWeight: 'bold' 
          }}>
            404 - Page Not Found
          </h1>
          <p style={{ 
            fontSize: '1.25rem', 
            marginBottom: '2rem', 
            color: 'var(--text-secondary)' 
          }}>
            Oops! The page you're looking for doesn't exist.
          </p>
          <Link to="/" className="btn btn--primary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  )
}
